import { Directive, effect, inject, input, InputSignal, TemplateRef, ViewContainerRef } from '@angular/core';
import { GlobalStore } from 'app/shared/store/global.store';
import { FeatureFlagType } from '../models/config/feature-flag.type';

@Directive({
  selector: '[appIfFeature]',
})
export class IfFeatureDirective {
  private readonly templateRef: TemplateRef<any> = inject(TemplateRef);
  private readonly viewContainer: ViewContainerRef = inject(ViewContainerRef);
  private readonly globalStore = inject(GlobalStore);

  public readonly appIfFeature: InputSignal<FeatureFlagType> = input<FeatureFlagType>();

  constructor() {
    effect(() => {
      const flag = this.appIfFeature();
      const isEnabled = this.globalStore.config()[flag];
      this.viewContainer.clear();
      if (isEnabled) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    });
  }
}
